import React from "react";
import useTheme from "src/hooks/useTheme";

interface ShimmerProps {
  className?: string;
  width?: string;
  height?: string;
  rounded?: string;
  backgroundColor?: string;
}

const Shimmer: React.FC<ShimmerProps> = ({
  className = "",
  width = "100px",
  height = "100px",
  rounded = "rounded-md",
  backgroundColor, // "#e2e8f0" (default shimmer background color)
}) => {
  const theme = useTheme();
  const resolvedBackgroundColor =
    backgroundColor || theme.colors?.shimmerBackground;
  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      <div
        className={`bg-[${resolvedBackgroundColor}] ${rounded} animate-pulse`}
        style={{ width, height }}
      ></div>
    </div>
  );
};

export default Shimmer;
